export default "__VITE_ASSET__1c68fd4e__"